import { IonicModule } from '@ionic/angular';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BackButtonModule } from '../../components/back-button/back-button.component.module';
import { HeaderModule } from 'src/app/components/header/header.module';
import { SafeHtmlsModule } from 'src/app/angular-wallet-base/pipes/safe-htmls/safe-htmls.module';
import { TabsModule } from 'src/app/components/home-page/tabs/tabs.module';
import { SelectPaymentModule } from '../select-payment-modal/select-payment-modal.module';
import { BuyAssetsComponent } from './buy-assets.component';
import { ReviewOrderComponent } from './review-order/review-order.component';
import { SuccessOrderComponent } from './success-order/success-order.component';
import { SelectAssetModule } from '../select-asset-modal/select-asset-modal.module';
import { AddMetalComponent } from './add-metal/add-metal.component';
import { ListMetalComponent } from './list-metal/list-metal.component';
import { MatSelectModule } from '@angular/material/select';
import { QrCodeForTransferComponent } from './qr-code-for-transfer/qr-code-for-transfer';
import { NgxKjuaModule } from 'ngx-kjua';
import { SwapWarningModalComponent } from './swap-caution-modal/swap-warning.modal';
import { SimplexCheckoutModalComponent } from './simplex-checkout/simplex-checkout';
import { PurchaseHistoryModalComponent } from './purchase-history/purchase-history.modal';
import { SimplexPaymentConfirmationModalComponent } from './simplex-payment-confirmation/payment-confirmation-modal';
import { DebounceDirectiveModule } from 'src/app/angular-wallet-base/directives/debounce/debounce-directive.module';
import { CreditCardFormModule } from '../../components/credit-card-form/credit-card-form.component.module';
import { SingularityOrderComponent } from './singularity-order/singularity-order.component';
import { StripeOrderComponent } from './stripe-order/stripe-order.component';

const routes: Routes = [
  {
    path: 'review-order',
    component: ReviewOrderComponent,
  },
  {
    path: 'singularity/:assets',
    component: SingularityOrderComponent,
  },
  {
    path: 'stripe/:assets',
    component: StripeOrderComponent,
  },
  {
    path: 'success',
    component: SuccessOrderComponent,
  },
  {
    path: 'qr-code-page',
    component: QrCodeForTransferComponent,
  },
  {
    path: ':asset',
    component: BuyAssetsComponent,
  },
];

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    TabsModule,
    RouterModule.forChild(routes),
    BackButtonModule,
    HeaderModule,
    SafeHtmlsModule,
    SelectPaymentModule,
    SelectAssetModule,
    MatSelectModule,
    NgxKjuaModule,
    DebounceDirectiveModule,
    CreditCardFormModule
  ],
  declarations: [
    BuyAssetsComponent,
    ReviewOrderComponent,
    SuccessOrderComponent,
    AddMetalComponent,
    ListMetalComponent,
    QrCodeForTransferComponent,
    SwapWarningModalComponent,
    SimplexCheckoutModalComponent,
    PurchaseHistoryModalComponent,
    SimplexPaymentConfirmationModalComponent,
    SingularityOrderComponent
  ],
  providers: [DecimalPipe],
})
export class BuyAssetsModule {}
